import React from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import CIISimulator, { CALCULATOR_TABS } from './CIISimulator';

function App() {
  return (
    <Router>
      <Routes>
        {/* Every calculator path renders the same shell, which reads the URL to
            pick the tab. Sharing one element type keeps it mounted across tab
            switches, so form state is not lost. */}
        {CALCULATOR_TABS.map(tab => (
          <Route key={tab.path} path={tab.path} element={<CIISimulator />} />
        ))}
        <Route path="/" element={<CIISimulator />} />
      </Routes>
    </Router>
  );
}

export default App;
